import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootStates } from 'redux/store';
import { apiUrl } from '../../constants/paths';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootStates).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getRecordSummary: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/${param.type}/summary?year=${param.year}&byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getObservationMetric: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/matrics/observations/positive-percent?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getIncidentsHighSevereMetric: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/matrics/incidents/high-severe?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getTasksOnTimeMetric: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/matrics/tasks/on-time?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getReInspectionFrequencyMetric: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/matrics/inspections/reinspection-frequency?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getPaperSaved: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/paper-saved?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getCo2Stats: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/co2-stats?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getAverageInspectionTime: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/avg-inspection-time?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getAverageApprovalTime: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/avg-approval-time?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getInspectionContribution: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/users/inspection-contribution?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getObservationContribution: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/users/observation-contribution?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getIncidentContribution: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/users/incident-contribution?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getInspectionRatingSummary: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/summary/inspections/rating?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getObservationAreaSummary: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/summary/observations/area?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
    getIncidentOccuranceSummary: build.mutation({
      query: (param) => ({
        url: `${apiUrl.project}/${param.projectId}/dashboard/summary/incidents/occurance?byUser=${param.userId}`,
        method: 'get',
      }),
    }),
  }),
});

export const {
  useGetRecordSummaryMutation,
  useGetObservationMetricMutation,
  useGetIncidentsHighSevereMetricMutation,
  useGetReInspectionFrequencyMetricMutation,
  useGetTasksOnTimeMetricMutation,
  useGetAverageApprovalTimeMutation,
  useGetAverageInspectionTimeMutation,
  useGetCo2StatsMutation,
  useGetPaperSavedMutation,
  useGetIncidentContributionMutation,
  useGetInspectionContributionMutation,
  useGetObservationContributionMutation,
  useGetIncidentOccuranceSummaryMutation,
  useGetInspectionRatingSummaryMutation,
  useGetObservationAreaSummaryMutation,
} = dashboardApi;
